import {
  Box,
  IconButton,
  TextField,
  Typography,
  Tabs,
  Tab,
  Menu,
  MenuItem,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LoopIcon from "@mui/icons-material/Loop";
import Grids from "../../components/grids";
import AuthContext from "../../contexts/authContext";
import axiosInstance from "../../api/axios";
import toast from "react-hot-toast";
import ViewCustomer from "../../components/modals/viewCustomer";
import ViewAsset from "../../components/modals/viewasset";
import ViewUser from "../../components/modals/viewUser";

const Trash = () => {
  const { userData, setRefresh } = useContext(AuthContext);

  const [currentTab, setCurrentTab] = useState("customers");
  const [search, setSearch] = useState("");

  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);

  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);

  const [rowId, setRowId] = useState("");
  const [openViewCustomer, setOpenViewCustomer] = useState(false);
  const [openViewAsset, setOpenViewAsset] = useState(false);
  const [openViewUser, setOpenViewUser] = useState(false);

  const role = localStorage.getItem("role");

  // -----------------------------
  // TABS CHANGE
  // -----------------------------
  const handleChangeTab = (e, newValue) => {
    setCurrentTab(newValue);
    setSearch("");
  };

  // -----------------------------
  // MENU OPEN / CLOSE
  // ------------------------------
  const handleOpenMenu = (event, id) => {
    setAnchorEl(event.currentTarget);
    setRowId(id);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  // -----------------------------
  // RESTORE API CALL
  // -----------------------------
  const handleRestore = async (id) => {
    if (!window.confirm(`Restore this ${currentTab}?`)) return;

    try {
      const res = await axiosInstance.patch(`/restore/${currentTab}/${id}`);

      if (res.status === 200) {
        toast.success(`${currentTab} restored successfully`);
        setRefresh(true);
      } else {
        toast.error(`Failed to restore ${currentTab}`);
      }
    } catch {
      toast.error("Error restoring");
    }
  };

  // -----------------------------
  // SET COLUMNS BASED ON TAB
  // -----------------------------
  const CustomerColumns = [
    {
      field: "id",
      headerName: "S.No",
      minWidth: 80,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "name",
      headerName: "Name",
      minWidth: 150,
      flex: 1,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "mobile",
      headerName: "Mobile",
      minWidth: 120,
      flex: 1,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "address",
      headerName: "Address",
      minWidth: 180,
      flex: 1.5,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "area",
      headerName: "Area",
      minWidth: 140,
      flex: 1,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "scheme",
      headerName: "Scheme",
      minWidth: 120,
      flex: 1,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
    },

    {
      field: "actions",
      headerName: "Actions",
      minWidth: 80,
      flex: 0.5,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <IconButton
          sx={{ color: "#800001" }}
          onClick={(e) => handleOpenMenu(e, params.row._id)}
        >
          <MoreVertIcon />
        </IconButton>
      ),
    },
  ];

  const AssetColumns = [
    {
      field: "id",
      headerName: "S.No",
      minWidth: 80,
      flex: 0.5,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "companyName",
      headerName: "Company",
      minWidth: 160,
      flex: 1,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "email",
      headerName: "Email",
      minWidth: 180,
      flex: 1,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "mobile",
      headerName: "Mobile",
      minWidth: 120,
      flex: 1,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "address",
      headerName: "Address",
      minWidth: 200,
      flex: 1.5,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 80,
      flex: 0.5,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <IconButton
          sx={{ color: "#800001" }}
          onClick={(e) => handleOpenMenu(e, params.row._id)}
        >
          <MoreVertIcon />
        </IconButton>
      ),
    },
  ];

  const SchemeColumns = [
    {
      field: "id",
      headerName: "S.No",
      minWidth: 80,
      flex: 0.5,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "schemeName",
      headerName: "Name",
      minWidth: 180,
      flex: 1,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "customers",
      headerName: "Customers",
      minWidth: 120,
      flex: 1,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 80,
      flex: 0.5,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <IconButton
          sx={{ color: "#800001" }}
          onClick={(e) => handleOpenMenu(e, params.row._id)}
        >
          <MoreVertIcon />
        </IconButton>
      ),
    },
  ];

  const UserColumns = [
    {
      field: "id",
      headerName: "S.No",
      minWidth: 80,
      flex: 1,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "name",
      headerName: "Name",
      minWidth: 150,
      flex: 1,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "mobile",
      headerName: "Mobile",
      minWidth: 120,
      flex: 1,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "username",
      headerName: "Username",
      minWidth: 150,
      flex: 1,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 80,
      flex: 0.5,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <IconButton
          sx={{ color: "#800001" }}
          onClick={(e) => handleOpenMenu(e, params.row._id)}
        >
          <MoreVertIcon />
        </IconButton>
      ),
    },
  ];

  const AreaColumns = [
    {
      field: "id",
      headerName: "S.No",
      minWidth: 80,
      flex: 0.5,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "areaName",
      headerName: "Area",
      minWidth: 180,
      flex: 1,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "customers",
      headerName: "Customers",
      minWidth: 120,
      flex: 1,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 80,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      flex: 0.7,
      renderCell: (params) => (
        <IconButton
          sx={{ color: "#800001" }}
          onClick={(e) => handleOpenMenu(e, params.row._id)}
        >
          <MoreVertIcon />
        </IconButton>
      ),
    },
  ];

  // -----------------------------
  // FILTER ROWS BASED ON TAB
  // -----------------------------
  useEffect(() => {
    if (!userData) return;

    const txt = search.toLowerCase();

    let result = [];
    let cols = [];

    if (currentTab === "customers") {
      cols = CustomerColumns;
      result = userData.customers
        ?.filter((c) => c.status === "erased")
        .filter(
          (c) =>
            c.name.toLowerCase().includes(txt) ||
            String(c.mobile).includes(txt) ||
            c.address?.toLowerCase().includes(txt)
        )
        .map((c, idx) => ({
          id: idx + 1,
          _id: c._id,
          name: c.name,
          mobile: c.mobile,
          address: c.address,
          area: c.area?.areaName,
          scheme: c.scheme?.length || 0,
        }));
    }

    if (currentTab === "assets") {
      cols = AssetColumns;
      result = userData.assets
        ?.filter((a) => a.status === "erased")
        .filter((a) => a.companyName.toLowerCase().includes(txt))
        .map((a, idx) => ({
          id: idx + 1,
          _id: a._id,
          companyName: a.companyName,
          email: a.email,
          mobile: a.mobile,
          address: a.address,
        }));
    }

    if (currentTab === "schemes") {
      cols = SchemeColumns;
      result = userData.schemes
        ?.filter((s) => s.status === "erased")
        .filter((s) => s.schemeName.toLowerCase().includes(txt))
        .map((s, idx) => ({
          id: idx + 1,
          _id: s._id,
          schemeName: s.schemeName,
          customers: userData.customers?.filter((c) =>
            c.scheme.some((sc) => sc.schemeId === s._id)
          ).length,
        }));
    }

    if (currentTab === "users") {
      cols = UserColumns;
      result = userData.users
        ?.filter((u) => u.status === "erased")
        .filter((u) => u.name.toLowerCase().includes(txt))
        .map((u, idx) => ({
          id: idx + 1,
          _id: u._id,
          name: u.name,
          mobile: u.mobile,
          username: u.username,
        }));
    }

    if (currentTab === "area") {
      cols = AreaColumns;
      result = userData.areas
        ?.filter((ar) => ar.status === "erased")
        .filter((ar) => ar.areaName.toLowerCase().includes(txt))
        .map((ar, idx) => ({
          id: idx + 1,
          _id: ar._id,
          areaName: ar.areaName,
          customers: userData.customers?.filter((c) => c.area?._id === ar._id)
            .length,
        }));
    }

    setColumns(cols);
    setRows(result);
  }, [currentTab, search, userData]);

  // -----------------------------
  // VIEW HANDLER (dynamic)
  // -----------------------------
  const openViewer = () => {
    if (currentTab === "customers") setOpenViewCustomer(true);
    if (currentTab === "assets") setOpenViewAsset(true);
    if (currentTab === "users") setOpenViewUser(true);
  };

  // -----------------------------
  // JSX
  // -----------------------------
  return (
    <>
      <Typography
        variant="h5"
        sx={{ textAlign: "center", color: "#800001", mb: 2 }}
      >
        Trash
      </Typography>

      {/* TABS */}
      <Tabs
        value={currentTab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
        TabIndicatorProps={{ style: { background: "#800001" } }}
        sx={{
          "& .MuiTab-root": { color: "#000", fontWeight: 600 },
          "& .Mui-selected": { color: "#800001 !important" },
        }}
      >
        <Tab label="Customers" value="customers" />
        <Tab label="Assets" value="assets" />
        <Tab label="Schemes" value="schemes" />
        <Tab label="Users" value="users" />
        <Tab label="Area" value="area" />
      </Tabs>

      {/* SEARCH */}
      <Box display="flex" justifyContent="flex-end" px={2} py={2}>
        <TextField
          placeholder="Search"
          variant="outlined"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{
            width: { xs: "100%", sm: "300px" },
            "& .MuiOutlinedInput-input": { padding: "10px", color: "#800001" },
            "& .MuiInputLabel-root": { color: "#800001" },
            "& .MuiInputLabel-shrink": { color: "#800001" },
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "#800001" },
              "&:hover fieldset": { borderColor: "#cc0000" },
              "&.Mui-focused fieldset": { borderColor: "#800001" },
            },
          }}
        />
      </Box>

      {/* GRID */}
      <Box sx={{ width: { xs: "95vw", sm: "81vw" } }}>
        <Grids columns={columns} rows={rows} />
      </Box>

      {/* VIEW MODALS */}
      <ViewCustomer
        setCustomerId={setRowId}
        openViewCustomer={openViewCustomer}
        setOpenViewCustomer={setOpenViewCustomer}
        customerId={rowId}
        deleted={true}
      />

      <ViewAsset
        openViewAsset={openViewAsset}
        setOpenViewAsset={setOpenViewAsset}
        assetId={rowId}
        setAssetId={setRowId}
      />

      <ViewUser
        openViewUser={openViewUser}
        setOpenViewUser={setOpenViewUser}
        userId={rowId}
        setUserId={setRowId}
      />

      {/* MENU */}
      <Menu anchorEl={anchorEl} open={openMenu} onClose={handleCloseMenu}>
        {(currentTab === "customers" ||
          currentTab === "assets" ||
          currentTab === "users") && (
          <MenuItem
            onClick={() => {
              openViewer();
              handleCloseMenu();
            }}
          >
            <VisibilityIcon sx={{ mr: 1 }} /> View
          </MenuItem>
        )}

        {role === "admin" && (
          <MenuItem
            onClick={() => {
              handleRestore(rowId);
              handleCloseMenu();
            }}
          >
            <LoopIcon sx={{ mr: 1 }} /> Restore
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default Trash;
